import { Typography } from "antd";
import {
  RiMoneyDollarCircleLine,
  RiHandCoinLine,
  RiFileSearchLine,
} from "react-icons/ri";

export const cards = [
  // {
  //   id: "irpf",
  //   icon: (
  //     <AiOutlineFileSearch
  //       size={24}
  //       className="no-fill"
  //       color="var(--ant-primary-color)"
  //     />
  //   ),
  //   content: (
  //     <Typography>
  //       Declaração IRPF
  //       <br />
  //       2023 no Velotax
  //     </Typography>
  //   ),
  // },
  {
    id: "anual-report",
    icon: (
      <RiFileSearchLine
        size={24}
        className="no-fill"
        color="var(--ant-primary-color)"
      />
    ),
    content: <Typography>Relatórios anuais</Typography>,
    description: (
      <Typography>
        Relatório auxiliar para preenchimento da DIRPF
      </Typography>
    ),
  },
  {
    id: "gain",
    icon: (
      <RiMoneyDollarCircleLine
        size={24}
        className="no-fill"
        color="var(--ant-primary-color)"
      />
    ),
    content: <Typography>INFORMES DE GANHO DE CAPITAL</Typography>,
    description: (
      <Typography>
        Relatórios auxiliares para acompanhamento do ganho de capital (GCAP)
      </Typography>
    ),
  },
  {
    id: "income",
    icon: (
      <RiHandCoinLine
        size={24}
        className="no-fill"
        color="var(--ant-primary-color)"
      />
    ),
    content: <Typography>INFORMES DE DIVIDENDOS</Typography>,
    description: (
      <Typography>
        Relatórios auxiliares para acompanhamento dos dividendos recebidos no
        exterior (carnê-leão)
      </Typography>
    ),
  },
];
